// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 获取系统错误日志列表 POST /apiAdmin/log/error/list */
export async function getErrorLogList(
  body: {
    keyword?: string;
    level?: string;
    status?: number;
    startTime?: string;
    endTime?: string;
    page?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/error/list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取未处理错误日志数量 GET /apiAdmin/log/error/unhandled-count */
export async function getUnhandledErrorCount(options?: {
  [key: string]: any;
}) {
  return request<any>("/apiAdmin/log/error/unhandled-count", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取系统错误日志详情 GET /apiAdmin/log/error/${param0} */
export async function getErrorLogById(
  params: { id: number },
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/log/error/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 处理错误日志 POST /apiAdmin/log/error/handle */
export async function handleErrorLog(
  body: {
    id: number;
    status: number;
    handleRemark?: string;
  },
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/error/handle", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除错误日志 DELETE /apiAdmin/log/error/${param0} */
export async function deleteErrorLog(
  params: { id: number },
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/log/error/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量删除错误日志 DELETE /apiAdmin/log/error/batch */
export async function batchDeleteErrorLog(
  body: { ids?: number[] },
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/error/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 清空错误日志 DELETE /apiAdmin/log/error/clear */
export async function clearErrorLog(options?: {
  [key: string]: any;
}) {
  return request<any>("/apiAdmin/log/error/clear", {
    method: "DELETE",
    ...(options || {}),
  });
}
